import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'semantic-ui-react'
import styled from 'styled-components'
import { darken } from 'polished'

const darkerColor = darken(0.03)

const CallToActionButton = ({
  createOnChange,
  createOnToggle,
  type,
  label,
  buttonLabel,
  link,
  isActive,
  iconClass,
  buttonClass,
  buttonStyles,
  iconImage,
}) => {
  const CustomButton = styled.a`
    &.ui.button {
      background-color: ${(props) => props.theme.backgroundColor && props.theme.backgroundColor};
      color: ${(props) => props.theme.color && props.theme.color};

      display: inline-flex;
      justify-content: center;
      align-items: center;

      &:hover,
      &:active,
      &:focus {
        background-color: ${(props) =>
          props.theme.backgroundColor && darkerColor(props.theme.backgroundColor)};
      }
    }
  `

  return (
    <div className="row">
      <div className="three wide column middle aligned">
        <div className="ui checkbox">
          <Checkbox
            label={label}
            name="isActive"
            onChange={createOnToggle({ type, buttonLabel })}
            checked={isActive}
          />
        </div>
      </div>

      <div className="six wide column">
        {type === 'custom' ? (
          <div className="ui input">
            <input
              type="text"
              name="label"
              onChange={createOnChange({ type, buttonLabel })}
              value={buttonLabel}
              placeholder="Button Text"
            />
          </div>
        ) : (
          <CustomButton theme={buttonStyles} className={`ui ${buttonClass} button`}>
            {iconImage ? (
              <img
                src={iconImage}
                alt={label}
                style={{
                  height: type === 'amazon' ? '12px' : '14px',
                  margin: '0 .375em 0 -.1875em',
                }}
              />
            ) : (
              <i className={iconClass} style={{ margin: '0 .375em 0 -.1875em' }} />
            )}
            <span>{buttonLabel}</span>
          </CustomButton>
        )}
      </div>

      <div className="seven wide column">
        <div className="ui fluid input">
          <input
            type="text"
            placeholder="https://www.example.com/yourprofile"
            name="link"
            onChange={createOnChange({ type, buttonLabel })}
            value={link}
          />
        </div>
      </div>
    </div>
  )
}

CallToActionButton.defaultProps = {
  buttonLabel: '',
  link: '',
  isActive: false,
}

CallToActionButton.propTypes = {
  createOnChange: PropTypes.func.isRequired,
  createOnToggle: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  iconClass: PropTypes.string,
  iconImage: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonStyles: PropTypes.object,
}

export default CallToActionButton



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CallToActionButton/index.js